const faqStructuredData = {
  init() {
    document.addEventListener('DOMContentLoaded', () => {
      const ldjsonElement = document.createElement('script')
      ldjsonElement.setAttribute('type', 'application/ld+json')

      const faqItems = this.getFaqItems()
      const ldJson = this.getFaqLdJsonContent(faqItems)

      if (ldJson) {
        const headElement = document.querySelector('head')
        headElement.appendChild(ldjsonElement)
        ldjsonElement.innerHTML = JSON.stringify(ldJson)
      }
    })
  },
  getFaqItems() {
    const faqItems = []
    const faqElement = document.querySelector('.nt-faq')
    if (!faqElement) return null

    const faqRows = faqElement.querySelectorAll('.droptext')
    if (!faqRows) return faqItems

    faqRows.forEach(row => {
      const question = row.querySelector('.droptext__title')
      const answer = row.querySelector('.droptext__content')
      faqItems.push({
        question: question.textContent,
        answer: answer.textContent
      })
    })
    return faqItems
  },
  getFaqLdJsonContent(faqItems) {
    if (!faqItems) return null

    const ldJson = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: faqItems.map(item => {
        return {
          '@type': 'Question',
          name: item.question,
          acceptedAnswer: {
            '@type': 'Answer',
            text: item.answer
          }
        }
      })
    }
    return ldJson
  }
}

faqStructuredData.init()
